import React, { useState } from 'react';
import './App.css';
import MainMenu from './components/MainMenu';
import EnhancedQuiz from './components/EnhancedQuiz';
import FlashcardStudy from './components/FlashcardStudy';
import CocktailFlashcards from './components/CocktailFlashcards';
import CoreCocktails from './components/CoreCocktails';
import TableScenarios from './components/TableScenarios';

function App() {
  const [currentView, setCurrentView] = useState('menu');
  const [selectedQuiz, setSelectedQuiz] = useState(null);

  const handleQuizSelect = (quizId) => {
    setSelectedQuiz(quizId);
    
    // Route to appropriate component based on quiz type
    switch (quizId) {
      case 'flashcards':
        setCurrentView('flashcards');
        break;
      case 'cocktail-flashcards':
        setCurrentView('cocktail-flashcards');
        break;
      case 'core-cocktails':
        setCurrentView('core-cocktails');
        break;
      case 'study-guide':
        setCurrentView('study-guide');
        break;
      case 'audio-study':
        setCurrentView('audio-study');
        break;
      case 'table-scenarios':
      case 'upselling-practice':
      case 'complaint-handling':
      case 'vip-service':
        setCurrentView('scenarios');
        break;
      default:
        setCurrentView('quiz');
    }
  };

  const handleBackToMenu = () => {
    // Force scroll to top
    window.scrollTo(0, 0);
    
    // Reset state
    setCurrentView('menu');
    setSelectedQuiz(null);
    
    // Force a re-render by updating the key
    console.log('Navigating back to menu');
    
    // Small delay to ensure state is fully reset
    setTimeout(() => {
      console.log('State reset complete, current view:', 'menu');
    }, 100);
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'quiz':
        return (
          <EnhancedQuiz 
            key={`quiz-${selectedQuiz}`}
            quizType={selectedQuiz}
            onBackToMenu={handleBackToMenu}
          />
        );
      case 'flashcards':
        return (
          <FlashcardStudy 
            key="flashcards"
            onBack={handleBackToMenu}
          />
        );
      case 'scenarios':
        return (
          <TableScenarios 
            key={`scenarios-${selectedQuiz}`}
            scenarioType={selectedQuiz}
            onBack={handleBackToMenu}
          />
        );
      case 'study-guide':
        return (
          <StudyGuide 
            key="study-guide"
            onBack={handleBackToMenu}
          />
        );
      case 'audio-study':
        return (
          <AudioStudy 
            key="audio-study"
            onBack={handleBackToMenu}
          />
        );
      case 'cocktail-flashcards':
        return (
          <CocktailFlashcards 
            key="cocktail-flashcards"
            onBack={handleBackToMenu}
          />
        );
      case 'core-cocktails':
        return (
          <CoreCocktails 
            key="core-cocktails"
            onBack={handleBackToMenu}
          />
        );
      case 'menu':
      default:
        return (
          <MainMenu 
            key="main-menu"
            onQuizSelect={handleQuizSelect}
          />
        );
    }
  };

  return (
    <div className="App">
      <div className="app-background">
        {renderCurrentView()}
      </div>
    </div>
  );
}

// Placeholder components for future implementation
const StudyGuide = ({ onBack }) => (
  <div style={{ 
    maxWidth: '800px', 
    margin: '0 auto', 
    padding: '2rem',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '15px',
    textAlign: 'center'
  }}>
    <button 
      onClick={onBack}
      style={{
        padding: '0.5rem 1rem',
        border: '2px solid #8B0000',
        backgroundColor: 'white',
        color: '#8B0000',
        borderRadius: '8px',
        cursor: 'pointer',
        marginBottom: '2rem'
      }}
    >
      ← Back to Menu
    </button>
    <h2 style={{ color: '#8B0000', marginBottom: '1rem' }}>📋 Study Guides</h2>
    <p style={{ color: '#666', fontSize: '1.1rem', marginBottom: '2rem' }}>
      Printable reference sheets coming soon! This will include quick reference cards for:
    </p>
    <ul style={{ textAlign: 'left', maxWidth: '500px', margin: '0 auto', color: '#333' }}>
      <li>Allergen quick reference chart</li>
      <li>Wine pairing cheat sheet</li>
      <li>Cooking technique definitions</li>
      <li>Upselling conversation starters</li>
      <li>VIP service checklist</li>
      <li>Emergency allergy protocols</li>
    </ul>
  </div>
);

const AudioStudy = ({ onBack }) => (
  <div style={{ 
    maxWidth: '800px', 
    margin: '0 auto', 
    padding: '2rem',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '15px',
    textAlign: 'center'
  }}>
    <button 
      onClick={onBack}
      style={{
        padding: '0.5rem 1rem',
        border: '2px solid #8B0000',
        backgroundColor: 'white',
        color: '#8B0000',
        borderRadius: '8px',
        cursor: 'pointer',
        marginBottom: '2rem'
      }}
    >
      ← Back to Menu
    </button>
    <h2 style={{ color: '#8B0000', marginBottom: '1rem' }}>🎧 Audio Study Mode</h2>
    <p style={{ color: '#666', fontSize: '1.1rem', marginBottom: '2rem' }}>
      Listen and learn while you work! Audio study mode coming soon with:
    </p>
    <ul style={{ textAlign: 'left', maxWidth: '500px', margin: '0 auto', color: '#333' }}>
      <li>Narrated menu descriptions</li>
      <li>Wine pairing explanations</li>
      <li>Cooking technique audio guides</li>
      <li>Service scenario audio drills</li>
      <li>Pronunciation guides for wine names</li>
      <li>Background study playlists</li>
    </ul>
  </div>
);

export default App;
